import { SERVER_URL } from '../../constants';
import { fetchPostAuth } from '../../util/FetchUtil';

const controller = 'credential-k8-pay';

export const saveCredentialK8Pay = (credentialK8Pay) => {
  const url = SERVER_URL + controller + "/save";
  return fetchPostAuth(url, credentialK8Pay);
}
